import { eventModal } from "@NextSkyTheme/modal";
import * as NextSkyTheme from "@NextSkyTheme/global";

class HighlightPopup extends HTMLElement {
  constructor() {
    super();
    this.boundHandleClick = this.handleClick.bind(this);
    this.boundHandleKeydown = this.handleKeydown.bind(this);
  }

  connectedCallback() {
    this.addEventListener("click", this.boundHandleClick, false);
    this.addEventListener("keydown", this.boundHandleKeydown, false);
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.boundHandleClick, false);
    this.removeEventListener("keydown", this.boundHandleKeydown, false);
  }

  handleClick(event) {
    event.preventDefault();
    this.openPopup();
  }

  handleKeydown(event) {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      this.openPopup();
    }
  }

  openPopup() {
    const template = this.querySelector(":scope > template");
    if (!template) return;

    const clone = template.content.cloneNode(true);
    const popupElement = clone.querySelector("highlight-popup-modal");
    if (!popupElement) return;

    NextSkyTheme.getBody().appendChild(popupElement);

    setTimeout(() => {
      eventModal(popupElement, "open", true, null, false);
    }, 100);

    NextSkyTheme.global.rootToFocus = this;
  }
}

customElements.define("highlight-popup", HighlightPopup);
